(function () {
  // Map page path -> value/label to force-select in the FIRST dropdown only
  const PAGE_PRESELECT = {
    "/pages/shop-qr3-bike-rack": "QR3",
    "/pages/shop-cinch-rack": "Cinch",
    "/pages/shop-qr3-bike-rack-for-decked": "QR3 for DECKED",
    "/pages/shop-cinch-rack-for-a-deck-box": "Cinch for DECKED",
  };

  const desired = PAGE_PRESELECT[window.location.pathname];
  if (!desired) return; // do nothing on other pages

  function normalize(s) {
    return (s || "").toString().trim().toLowerCase();
  }

  function findFirstMMYSelect() {
    // We only want the FIRST dropdown on the page (the "Make/Model/Year" first select).
    // Try common patterns first, then fall back to "first select that has placeholder-ish option".
    const candidates = Array.from(document.querySelectorAll("select"));

    // If your widget uses a container, prefer selects inside it (reduces accidental matches).
    const widgetRoot =
      document.querySelector("[data-ymm], [data-mmy], .ymm, .mmy, .vehicle-search, .easysearch") ||
      document;

    const scoped = Array.from(widgetRoot.querySelectorAll("select"));
    const list = scoped.length ? scoped : candidates;

    // Heuristic: first dropdown usually has placeholder like Make/Model/Year or Select Make
    for (const sel of list) {
      const firstOpt = sel.options && sel.options[0];
      const t = normalize(firstOpt ? firstOpt.textContent : "");
      if (
        t.includes("make") ||
        t.includes("model") ||
        t.includes("year") ||
        t.includes("make/model/year") ||
        t.includes("select")
      ) {
        return sel;
      }
    }

    // Fallback: just return first select in the widget root
    return list[0] || null;
  }

  function setSelectByLabelOrValue(select, labelWanted) {
    if (!select || !select.options || select.options.length === 0) return false;

    const wanted = normalize(labelWanted);

    // If already set correctly, stop.
    const current = select.options[select.selectedIndex];
    if (current && normalize(current.textContent) === wanted) return true;

    // Find matching option by visible text (preferred)
    let matchIndex = -1;
    for (let i = 0; i < select.options.length; i++) {
      const opt = select.options[i];
      if (!opt || opt.disabled) continue;
      if (normalize(opt.textContent) === wanted) {
        matchIndex = i;
        break;
      }
    }

    // Fallback: match by value
    if (matchIndex === -1) {
      for (let i = 0; i < select.options.length; i++) {
        const opt = select.options[i];
        if (!opt || opt.disabled) continue;
        if (normalize(opt.value) === wanted) {
          matchIndex = i;
          break;
        }
      }
    }

    if (matchIndex === -1) return false;

    select.selectedIndex = matchIndex;

    // Trigger the widget to load the next dropdown, but we will NOT auto-select those.
    select.dispatchEvent(new Event("change", { bubbles: true }));
    select.dispatchEvent(new Event("input", { bubbles: true }));
    return true;
  }

  function init() {
    const firstSelect = findFirstMMYSelect();
    if (!firstSelect) return;

    // Try now (in case options already present)
    if (setSelectByLabelOrValue(firstSelect, desired)) return;

    // Options may be injected async. Watch ONLY the first select for changes.
    const mo = new MutationObserver(() => {
      if (setSelectByLabelOrValue(firstSelect, desired)) {
        mo.disconnect();
      }
    });
    mo.observe(firstSelect, { childList: true, subtree: true });

    // Also retry a few times just in case the widget rebuilds the select element
    let tries = 0;
    const timer = setInterval(() => {
      tries += 1;
      const sel = findFirstMMYSelect();
      if (sel && setSelectByLabelOrValue(sel, desired)) {
        clearInterval(timer);
      }
      if (tries >= 20) clearInterval(timer); // ~5 seconds total
    }, 250);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
